module.exports = "<div class=\"checkbox lookup-bulk-select q-checkbox checkbox-purple cb-middle cb-unchecked-white\"> <label> <input type=checkbox value=\"lookup-bulk-select-{%- value %}\" id=\"lookup-bulk-select-{%- value %}\" name=\"lookup-bulk-select-{%- value %}\" class=\"lookup-bulk-select-{%- placement %}\"/> <span class=cb-label-inner> </span> </label> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/bulkSelectTemplate.html
// module id = 1143
// module chunks = 1